/* ============================================================
   ATELIER BROCHURES  -  render logic for /pages/brochures
   Reads:
     window.ATBrochures        (atelier-brochures-data.js  - generated)
     window.ATBrochureBrands   (atelier-brochures-data.js  - generated)
     window.ATBrandLogos       (emitted by sections/atelier-brochures.liquid,
                                mirrors the window.ATBrandSVG convention in the header)
   Covers are absolute Shopify Files CDN URLs; brochures without one get a
   deliberate placeholder cover rather than a broken image.
   Cards link to #read=<id> and open the overlay reader
   (atelier-brochures-reader.js, loaded before this file); the hash is the
   shareable deep link (#read=<id>&p=<page>). readable:false cards toast
   instead of opening a dead reader.
   ============================================================ */
(function () {
  var root = document.getElementById('atbr');
  if (!root || !window.ATBrochures) return;

  var B = window.ATBrochures, BR = window.ATBrochureBrands || [], LOGO = window.ATBrandLogos || {};
  var PAGE = root.getAttribute('data-page-url') || '';

  var CATS = ['All', 'Full range', 'Vanities & Basins', 'Tapware & Showers', 'Sanitaryware',
              'Heating', 'Kitchen & Laundry', 'Accessories & Mirrors', 'Accessible', 'Guides'];
  var LOCKUP = { 'modern-national': 'Modern National' };   /* monogram-only SVG */
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  var cat = 'All', view = 'supplier', sort = 'supplier';
  var $ = function (id) { return document.getElementById(id); };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var brandOf = {}; BR.forEach(function (b) { brandOf[b.id] = b; });
  var counts = {}; B.forEach(function (x) { counts[x.brand] = (counts[x.brand] || 0) + 1; });
  /* richest supplier first; the gated one (Greens) sits last */
  var order = BR.slice().sort(function (a, b) {
    if (a.id === 'greens') return 1;
    if (b.id === 'greens') return -1;
    return (counts[b.id] || 0) - (counts[a.id] || 0) || a.name.localeCompare(b.name);
  });

  function logoImg(id) {
    var src = LOGO[id];
    return src ? '<img src="' + src + '" alt="" loading="lazy">' : '';
  }
  /* supplier panel: Modern National's monogram gets a typeset wordmark beside it */
  function logoPanel(id, name) {
    var src = LOGO[id];
    if (!src) return '<span class="atbr-word">' + esc(name) + '</span>';
    if (LOCKUP[id]) return '<span class="atbr-lock"><img src="' + src + '" alt="' + esc(name) + '"><span class="atbr-word">' + esc(LOCKUP[id]) + '</span></span>';
    return '<img src="' + src + '" alt="' + esc(name) + '">';
  }

  /* ---------------- hero fan: offsets derived from the container, never hard-coded ---------------- */
  var PICK = ['mn-bordeaux', 'zm-essential', 'gb-hidden-beauty', 'tg-product-guide', 'mn-nova', 'hw-catalogue'];
  var fan = $('atbr-fan'), fanCards = [];
  PICK.forEach(function (id) {
    var b = B.filter(function (x) { return x.id === id; })[0];
    if (!b || !b.cover) return;
    var d = document.createElement('div');
    d.className = 'f';
    d.innerHTML = '<img src="' + b.cover + '" alt="" loading="lazy">';
    fan.appendChild(d); fanCards.push(d);
  });
  function layoutFan() {
    var n = fanCards.length; if (!n) return;
    var fw = fan.clientWidth || 520, mid = (n - 1) / 2;
    var cw = Math.max(106, Math.min(172, fw * 0.33));
    var step = n > 1 ? Math.min(104, Math.max(0, fw - cw - 56) / (n - 1)) : 0;
    fanCards.forEach(function (d, i) {
      var off = i - mid;
      d.style.width = cw + 'px';
      d.style.zIndex = String(10 - Math.abs(off));
      d.style.transform = 'translate(-50%,-50%) translateX(' + (off * step).toFixed(1) + 'px) translateY('
        + (Math.abs(off) * 8) + 'px) rotate(' + (off * 4.6).toFixed(2) + 'deg)';
    });
  }
  layoutFan();
  addEventListener('resize', layoutFan);

  /* ---------------- toolbar ---------------- */
  var chips = $('atbr-chips');
  CATS.forEach(function (c) {
    var n = c === 'All' ? B.length : B.filter(function (x) { return x.cat === c; }).length;
    if (!n) return;
    var b = document.createElement('button');
    b.className = 'atbr-chip'; b.type = 'button'; b.textContent = c;
    b.setAttribute('aria-pressed', String(c === cat));
    b.onclick = function () {
      cat = c;
      [].forEach.call(chips.children, function (k) { k.setAttribute('aria-pressed', String(k.textContent === cat)); });
      paint();
    };
    chips.appendChild(b);
  });
  $('atbr-seg').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    view = b.getAttribute('data-view');
    [].forEach.call(this.children, function (k) { k.setAttribute('aria-pressed', String(k.getAttribute('data-view') === view)); });
    $('atbr-sort').hidden = view !== 'all';
    $('atbr-index').style.display = view === 'supplier' ? '' : 'none';
    paint();
  });
  $('atbr-sort').onchange = function () { sort = this.value; paint(); };

  function match(x) { return cat === 'All' || x.cat === cat; }
  function meta(x) {
    var b = [];
    if (x.pages) b.push(x.pages + ' page' + (x.pages === 1 ? '' : 's'));
    if (x.year) b.push(x.year);
    return b.join(' · ');
  }
  var toastT;
  function toast(m) {
    var t = $('atbr-toast'); t.textContent = m; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3600);
  }

  function card(x, showBrand) {
    var a = document.createElement('a');
    a.className = 'atbr-card' + (x.gated ? ' is-gated' : '');
    if (!x.gated) a.href = '#read=' + encodeURIComponent(x.id);
    var bn = (brandOf[x.brand] || {}).name || '';
    var read = x.gated ? '' : '<span class="atbr-read">Read</span>';
    var cov = x.cover
      ? '<div class="atbr-cov"><img src="' + x.cover + '" alt="' + esc(bn + ' ' + x.title) + ' cover" loading="lazy">' + read + '</div>'
      : '<div class="atbr-cov is-ph"><span class="pb">' + esc(bn) + '</span><span class="pt">' + esc(x.title) + '</span>'
        + '<span class="pn">' + (x.gated ? 'On request' : 'Cover pending') + '</span>' + read + '</div>';
    a.innerHTML = cov + '<div class="atbr-cb">'
      + (showBrand ? '<div class="b">' + esc(bn) + '</div>' : '')
      + '<div class="t">' + esc(x.title) + '</div><div class="m">' + meta(x) + '</div>'
      + (x.gated ? '<span class="atbr-tag">Request from supplier</span>' : '')
      + '</div>';
    if (x.gated) {
      a.onclick = function (e) { e.preventDefault(); toast('Greens publish this one behind a signup — we request the PDF from the rep.'); };
    } else if (!x.readable) {
      a.onclick = function (e) { e.preventDefault(); toast('“' + x.title + '” isn’t imported yet — its pages are still being brought in.'); };
    } else {
      a.onclick = function (e) {
        e.preventDefault();
        if (!window.AtelierBrochureReader) return;
        AtelierBrochureReader.open(x, { coverEl: a.querySelector('.atbr-cov'), brandName: bn });
      };
    }
    return a;
  }

  function paint() {
    var out = $('atbr-out'); out.innerHTML = '';
    var vis = B.filter(match);
    $('atbr-count').innerHTML = '<b>' + vis.length + '</b> of ' + B.length;

    var idx = $('atbr-index'); idx.innerHTML = '';
    order.forEach(function (br) {
      var n = B.filter(function (x) { return x.brand === br.id && match(x); }).length;
      if (!n) return;
      /* tile = logo box + name/count caption, exactly like the header's Brands panel.
         Modern National shows its bare monogram here; the caption carries the name. */
      var src = LOGO[br.id], isSvg = !!src && /\.svg(\?|$)/i.test(src);
      var a = document.createElement('a');
      a.className = 'atbr-ix'; a.href = '#atbr-s-' + br.id;
      a.setAttribute('data-key', br.id); a.title = br.name;
      a.innerHTML = '<span class="atbr-ix-im' + (isSvg ? ' atbr-ix-im--svg' : '') + '">'
        + (src ? logoImg(br.id) : '<b class="atbr-ix-nm">' + esc(br.name) + '</b>')
        + '</span><span class="atbr-ix-cap"><b>' + esc(br.name) + '</b><small>' + n + '</small></span>';
      idx.appendChild(a);
    });

    if (!vis.length) { out.innerHTML = '<p class="atbr-empty">No brochures in this category yet.</p>'; return; }

    if (view === 'supplier') {
      order.forEach(function (br) {
        var items = B.filter(function (x) { return x.brand === br.id && match(x); });
        if (!items.length) return;
        var sec = document.createElement('section');
        sec.className = 'atbr-sup'; sec.id = 'atbr-s-' + br.id; sec.setAttribute('data-key', br.id);
        var left = document.createElement('div');
        left.className = 'atbr-sup-id';
        left.innerHTML = '<div class="atbr-sup-logo">' + logoPanel(br.id, br.name) + '</div>'
          + '<p class="atbr-brief">' + esc(br.brief) + '</p>'
          + '<div class="atbr-cnt">' + items.length + ' brochure' + (items.length === 1 ? '' : 's') + '</div>'
          + '<a class="atbr-shop" href="/pages/brands">Shop ' + esc(br.name) + ' ' + ARROW + '</a>';
        var g = document.createElement('div'); g.className = 'atbr-grid';
        items.forEach(function (x) { g.appendChild(card(x, false)); });
        sec.appendChild(left); sec.appendChild(g); out.appendChild(sec);
      });
    } else {
      var items = vis.slice();
      if (sort === 'most') items.sort(function (a, b) { return (b.pages || 0) - (a.pages || 0); });
      if (sort === 'fewest') items.sort(function (a, b) { return (a.pages || 1e9) - (b.pages || 1e9); });
      if (sort === 'supplier') items.sort(function (a, b) {
        return order.indexOf(brandOf[a.brand]) - order.indexOf(brandOf[b.brand]) || a.title.localeCompare(b.title);
      });
      var sec = document.createElement('section');
      sec.style.padding = 'clamp(30px,4vw,46px) 0';
      var g = document.createElement('div'); g.className = 'atbr-grid is-flat';
      items.forEach(function (x) { g.appendChild(card(x, true)); });
      sec.appendChild(g); out.appendChild(sec);
    }
  }

  $('atbr-nbroch').textContent = B.length;
  $('atbr-nbrands').textContent = BR.length;
  paint();

  /* deep link: /pages/brochures#read=<id>[&p=N] opens the reader directly
     (the reader script loads before this one, so the API exists here) */
  var wantHash = location.hash.match(/^#read=([\w-]+)/);
  if (wantHash) {
    var rec = B.filter(function (x) { return x.id === wantHash[1] && x.readable && !x.gated; })[0];
    if (rec && window.AtelierBrochureReader) {
      AtelierBrochureReader.open(rec, { fromHash: true, brandName: (brandOf[rec.brand] || {}).name });
    } else if (!rec) {
      toast('That brochure isn’t in the library.');
    }
  }
})();
